export default __webpack_public_path__ + "static/tag-do-4-light-d0a2c308df448f092fd7508b7c1ceb43d7ce3a002b0433a42245c4f1ecc911e2.png";